export default __webpack_public_path__ + "static/media/sun-horizon.b4def5bb.svg";